var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-page-wrapper" }, [
    _c("div", { staticClass: "search-page-header" }, [
      _c("div", { staticClass: "search-page-key" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.key,
              expression: "key",
            },
          ],
          attrs: { val: "", placeholder: _vm.text.search_placeholder },
          domProps: { value: _vm.key },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.key = $event.target.value
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search-page-title" }, [
      _vm._v(_vm._s(_vm.text.search_title)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search-page-used-key" }, [
      _vm._v("«" + _vm._s(_vm.active_key) + "»"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search-page-modes clearfix" }, [
      _c(
        "div",
        {
          staticClass: "search-page-mode",
          class: { active: _vm.mode == "journal" },
          on: {
            click: function ($event) {
              _vm.mode = "journal"
            },
          },
        },
        [_vm._v(_vm._s(_vm.text.mode_journal))]
      ),
      _vm._v(" "),
      _vm.show_norm
        ? _c(
            "div",
            {
              staticClass: "search-page-mode",
              class: { active: _vm.mode == "norm" },
              on: {
                click: function ($event) {
                  _vm.mode = "norm"
                },
              },
            },
            [_vm._v(_vm._s(_vm.text.mode_norm))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.totalCount && _vm.mode == "journal"
      ? _c("div", {
          staticClass: "search-page-details",
          domProps: { innerHTML: _vm._s(_vm.searchPageDetails) },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.mode == "norm" && _vm.show_norm
      ? _c("div", { staticClass: "norm-filters clearfix" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.doc_status,
                  expression: "doc_status",
                },
              ],
              staticClass: "norm-filter doc-status-filter",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.doc_status = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "0" } }, [
                _vm._v("Статус документа"),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.doc_statuses,
                function (doc_status_label, doc_status_id) {
                  return _c("option", {
                    domProps: {
                      value: doc_status_id,
                      innerHTML: _vm._s(doc_status_label),
                    },
                  })
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.doc_number,
                expression: "doc_number",
              },
            ],
            staticClass: "norm-filter doc-number-filter",
            attrs: { placeholder: "Номер" },
            domProps: { value: _vm.doc_number },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.doc_number = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.doc_producer,
                  expression: "doc_producer",
                },
              ],
              staticClass: "norm-filter doc-producer-filter",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.doc_producer = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "0" } }, [
                _vm._v(_vm._s(_vm.text.publisher)),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.doc_producers,
                function (doc_producer_label, doc_producer_id) {
                  return _c("option", {
                    domProps: {
                      value: doc_producer_id,
                      innerHTML: _vm._s(doc_producer_label),
                    },
                  })
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.doc_type,
                  expression: "doc_type",
                },
              ],
              staticClass: "norm-filter doc-type-filter",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.doc_type = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "0" } }, [
                _vm._v("Тип документа"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.doc_types, function (doc_type) {
                return _c("option", {
                  domProps: {
                    value: doc_type.id,
                    innerHTML: _vm._s(doc_type.label),
                  },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "norm-filter date-filters-wrapper" }, [
            _vm._v("\n      " + _vm._s(_vm.text.text_from) + "    "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.date_from,
                  expression: "date_from",
                },
              ],
              staticClass: "date-from-filter",
              attrs: { placeholder: _vm.text.placeholder_date },
              domProps: { value: _vm.date_from },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.date_from = $event.target.value
                },
              },
            }),
            _vm._v(" " + _vm._s(_vm.text.text_to) + "   "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.date_to,
                  expression: "date_to",
                },
              ],
              staticClass: "date-to-filter",
              attrs: { placeholder: _vm.text.placeholder_date },
              domProps: { value: _vm.date_to },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.date_to = $event.target.value
                },
              },
            }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search-page-results" },
      [
        _vm._l(_vm.items, function (item) {
          return _vm.mode == "norm" && _vm.show_norm
            ? _c("norm-item", { key: item.id, attrs: { item: item } })
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.articles, function (item) {
          return _vm.mode == "journal"
            ? _c("article-item", { key: item.id, attrs: { item: item } })
            : _vm._e()
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }